import React from 'react'
import { Box, CssBaseline } from '@mui/material'
import { Profile } from 'src/features/profile'

const ProfilePage: React.FC = () => {
  return (<Box sx={{ backgroundColor: 'bw.white' }}>
    <CssBaseline />
    <Profile />
  </Box>)
}

export default ProfilePage
